import React, { useState } from 'react';
import { FiSearch, FiPrinter, FiRefreshCw, FiPlus } from 'react-icons/fi';
import AdminNavbar from './AdminNavbar';
import AdminSidebar from './AdminSidebar';
import OrderList from './orders/OrderList';
import OrderDetails from './orders/OrderDetails';
import RefundRequests from './orders/RefundRequests';
import ManualOrders from './orders/ManualOrders';

const AdminOrders = () => {
  const [activeTab, setActiveTab] = useState('orders');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const [showManualOrderModal, setShowManualOrderModal] = useState(false);
  const [orders, setOrders] = useState([
    { 
      id: 1001, 
      customer: 'John Doe', 
      date: '2023-05-15', 
      amount: 89.99, 
      status: 'pending', 
      items: 2,
      trackingNumber: '',
      paymentStatus: 'paid'
    },
    // ... other sample orders
  ]);

  const handleViewOrder = (order) => {
    setSelectedOrder(order);
    setShowOrderDetails(true);
  };

  const handleBackToList = () => {
    setShowOrderDetails(false);
    setSelectedOrder(null);
  };

  const handleStatusUpdate = (orderId, newStatus) => {
    setOrders(orders.map(order => 
      order.id === orderId ? { ...order, status: newStatus } : order
    ));
    
    // API call would go here in a real application
    console.log(`Order ${orderId} status updated to ${newStatus}`);
  };

  const handleRefresh = () => {
    // Implement refresh logic here
    console.log("Refreshing orders...");
  };

  const handleCreateManualOrder = (orderData) => {
    // Handle the new order creation
    console.log('New order data:', orderData);
    // Here you would typically:
    // 1. Make an API call to create the order
    // 2. Add the new order to your local state
    // 3. Close the modal
    setShowManualOrderModal(false);
    handleRefresh(); // Refresh the orders list
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <AdminNavbar />
      <div className="flex">
        <AdminSidebar />
        <main className="flex-1 p-6 overflow-x-hidden">
          <h1 className="text-2xl font-bold mb-6">Orders Management</h1>
          
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
              <h2 className="text-xl font-semibold text-gray-800">Order Management</h2>
              <div className="flex space-x-2">
                <button 
                  onClick={() => setShowManualOrderModal(true)}
                  className="flex items-center px-3 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
                >
                  <FiPlus className="mr-2" /> Create Manual Order
                </button>
                <button 
                  onClick={handleRefresh}
                  className="flex items-center px-3 py-2 bg-gray-100 rounded-md hover:bg-gray-200"
                >
                  <FiRefreshCw className="mr-2" /> Refresh
                </button>
              </div>
            </div>

            <div className="px-6 py-4 border-b border-gray-200">
              <div className="flex space-x-4">
                <button
                  onClick={() => setActiveTab('orders')}
                  className={`px-4 py-2 rounded-md ${activeTab === 'orders' ? 'bg-indigo-100 text-indigo-700' : 'hover:bg-gray-100'}`}
                >
                  Order List
                </button>
                {/* <button
                  onClick={() => setActiveTab('refunds')}
                  className={`px-4 py-2 rounded-md ${activeTab === 'refunds' ? 'bg-indigo-100 text-indigo-700' : 'hover:bg-gray-100'}`}
                >
                  Refund Requests
                </button> */}
              </div>
            </div>

            <div className="p-6">
              {showOrderDetails ? (
                <OrderDetails 
                  order={selectedOrder} 
                  onBack={handleBackToList}
                  onStatusUpdate={handleStatusUpdate}
                />
              ) : (
                <>
                  {activeTab === 'orders' ? (
                    <OrderList 
                      orders={orders}
                      onViewOrder={handleViewOrder}
                      onStatusUpdate={handleStatusUpdate}
                    />
                  ) : (
                    <RefundRequests />
                  )}
                </>
              )}
            </div>
          </div>

          {/* Manual Order Modal */}
          <ManualOrders
            isOpen={showManualOrderModal}
            onClose={() => setShowManualOrderModal(false)}
            onSubmit={handleCreateManualOrder}
          />
        </main>
      </div>
    </div>
  );
};

export default AdminOrders;